/**
 * Helpers for slots because of limitations in vue 3
 *
 * https://github.com/vuejs/core/issues/4733
 */
import { Comment, Text, Fragment, type Slot, type VNode } from 'vue';

// eslint-disable-next-line no-nested-ternary
export const asArray = <T>(arg: T | Array<T> | null) => (Array.isArray(arg) ? arg : arg === null ? [] : [arg]);

export const isVNodeEmpty = (vnodes: VNode | Array<VNode> | undefined | null) =>
  !vnodes ||
  asArray(vnodes).every(
    (vnode) =>
      vnode.type === Comment ||
      (vnode.type === Text && !vnode.children?.length) ||
      (vnode.type === Fragment && !vnode.children?.length)
  );

/**
 * Check if a slot is empty
 */
export const isSlotEmpty = (slot: Slot | undefined | null, props: any = {}) => isVNodeEmpty(slot?.(props));

/**
 * Check if a slot has content
 */
export const hasSlotContent = (slot: Slot | undefined | null, props: any = {}) => !isSlotEmpty(slot, props);
